// extracted by mini-css-extract-plugin
export default {"outputStyle":"code-output_outputStyle__g5su9","error":"code-output_error__WVXnl","spinner":"code-output_spinner__Hh36m","spin":"code-output_spin__Cw1Dt"};